export enum OrganizationState {
    TRIAL = 'TRIAL',
    CLIENT = 'CLIENT', //PAYING
    ON_HOLD = 'ON_HOLD',
    CHURNED = 'CHURNED',
    BLOCKED = 'BLOCKED',
}
